import { Divider, List, ListItem, ListSubheader, Typography } from "@mui/material";
import { MainCharacterList, NeighbourCharacterList, RecurringCharacterList } from "../dataset/character_data";
import Character from "../models/character";
import { CharacterProfile } from "../views/character_tile";

export const CharactersPage: React.FC = () => {

    // const theme = useTheme();

    return <>
        <List>
            {getCharacterListSection(MainCharacterList, "Main")}
            {getCharacterListSection(NeighbourCharacterList, "Neighbours")}
            {getCharacterListSection(RecurringCharacterList, "Recurring")}
        </List>
    </>;

    function getCharacterListSection(characterList: Character[], sectionHeading: string) {
        return <>
            <ListSubheader>
                <Typography variant="button" fontWeight="bold" paddingLeft={1} color={"black"}>
                    {sectionHeading}
                </Typography>
                <Divider />
            </ListSubheader>
            {characterList.map((character, index) => <>
                <ListItem key={character.name}>
                    <CharacterProfile character={character} />
                </ListItem>
                {index === characterList.length - 1
                    ? null
                    : <Divider component="li" />}
            </>)}
        </>
    }
}

/* Code for having a nested list

    const [showMainCharacters, setShowMainCharacters] = useState(false);

return <>
        <List>
            <ListItemButton onClick={() => setShowMainCharacters(!showMainCharacters)}>
                <ListItemText primary={"Main Characters"} />
                {showMainCharacters ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={showMainCharacters}>
                <List component="div">
                    {MainCharacterList.map((character) => (
                        <ListItem key={character.name}>
                            <CharacterProfile character={character} />
                        </ListItem>
                    ))}
                </List>
            </Collapse>
        </List>
    </>;
    
*/